import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";
import { encode as base64_encode } from "base-64";

class LicenseControlStore {
  licenses = [];
  assetList = [];
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      licenses: observable,
      assetList: observable,
      total: observable,
      loading: observable,
      loadData: action,
      updateLicense: action,
      deleteRecord: action,
      getAssetList: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId,assetName ,deviceId  }) {
    this.loading = true;

    const params = {
      offset,
      limit,
      companyId,
      assetName,
      deviceId,
    };
    console.log("AAAAAAAAAAA",params);

    const response = await postApi
      .getClient("")
      .post(config.NodeUrl +"/license/getLicenseControl",  params );

    console.log("response?.data?.data?.licenseControl",response?.data?.data?.licenseControl)

    if (response?.data?.data === null) {
      this.licenses = [];
    } else {
      this.licenses = response?.data?.data?.licenseControl ?? [];
    }

    this.total = parseInt(response?.data?.TotalCount) || 0;
    this.loading = false;
  }

  async generateLicense(data) {
    const response = await postApi
      .getClient("")
      .post( config.NodeUrl +"/license/generatelicensenumber", data);

    return response;
  }

  async updateLicense(data) {
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/updateSensor", data);

    return response;
  }

  async deleteRecord(postData) {
    console.log("delete postdata",postData);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl +"/license/deleteLicenseControl",  postData );
   

    return response;
  }

  async getAssetList({ companyId }) {
    const postData = { companyId };
    console.log("PostData",postData);

    const response = await postApi
      .getClient("")
      .post(config.NodeUrl +"/license/getlicenseVehicles",  postData );
   

    this.assetList = response?.data?.data;
    return this.assetList;
  }
  async exportExcel(postData) {
  console.log("postData", postData);

  const response = await postApi
    .getClient("")
    .post(config.NodeUrl +"/license/licensecontrolexcel",
  postData,
      {
        responseType: "blob", // ✅ keeps binary intact
      }
    );

      // ✅ Trigger file download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "license_control_report.xlsx"); // ✅ file name
      document.body.appendChild(link);
      link.click();

      // ✅ Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      return response;
    }
}

export default LicenseControlStore;
